import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import moment from "moment";
import React from "react";
import useGetThirdPartyCustomerInfo from "../../../../custom-hooks/useGetThirdPartyCustomerInfo";

interface ICustomerInformation {
  customerId: string | number;
}

const CustomerInformation = ({ customerId }: ICustomerInformation) => {
  const {
    data: thirdPartyCustomerInfo,
    isLoading: isLoadingThirdPartyCustomerInfo,
  } = useGetThirdPartyCustomerInfo(Number(customerId));

  let RenderedComponent = null;
  if (isLoadingThirdPartyCustomerInfo) {
    RenderedComponent = <p>Loading...</p>;
  } else if (!thirdPartyCustomerInfo?.data) {
    RenderedComponent = <p>No Customer Data</p>;
  } else {
    RenderedComponent = (
      <>
        <MDBTable
          responsive
          minimal="true"
          striped
          bordered
          hover
          id="table-to-xls"
        >
          <MDBTableHead>
            <tr>
              <th>Name</th>
              <th>Account Number</th>
              <th>BVN</th>
              <th>Company Name</th>
              <th>First Payment Date</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {
              <tr key={thirdPartyCustomerInfo?.data?.id}>
                <td>{thirdPartyCustomerInfo?.data?.name}</td>
                <td>{thirdPartyCustomerInfo?.data?.accountNumber}</td>
                <td>{thirdPartyCustomerInfo?.data?.bvn}</td>
                <td>{thirdPartyCustomerInfo?.data?.companyName}</td>
                <td>
                  {moment(
                    thirdPartyCustomerInfo?.data?.firstPaymentDate,
                  ).format("DD-MMM-YYYY")}
                </td>
              </tr>
            }
          </MDBTableBody>
        </MDBTable>
      </>
    );
  }
  return (
    <div>
      <h4 className="mb-2">Customer Information</h4>
      <div>{RenderedComponent}</div>
    </div>
  );
};

export default CustomerInformation;
